import { BaseHealthCardParser } from "./BaseHealthCardParser";

export class NewBrunswickHealdCardNumberParser extends BaseHealthCardParser {
    private OneDimensionRegex = /^\d{9}$/;
    private TwoDimensionRegex = [];

    protected GetOneDimensionRegex(): RegExp {
        return this.OneDimensionRegex;
    }

    protected GetTwoDimensionRegex(): RegExp[] {
        return this.TwoDimensionRegex;
    }
}



// WEBPACK FOOTER //
// ./src/services/HealthCardBarcodeScanParsers/NewBrunswickHealthCardParser.ts